import { api } from '../../api'

export const summaryReportApi = api
  .enhanceEndpoints({
    addTagTypes: ['department-summary'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDepartmentSummary: builder.query({
        providesTags: ['department-summary'],
        query: (params) => {
          return {
            url: '/dmp/department-summary',
            method: 'GET',
            params,
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getDepartmentSummaryReport: builder.mutation({
        query: (params) => {
          return {
            url: '/dmp/department-summary/xlsx',
            method: 'GET',
            params,
            responseHandler: async (response) => response.blob(),
          }
        },
      }),
    }),
  })

export const {
  useGetDepartmentSummaryQuery,
  useGetDepartmentSummaryReportMutation,
} = summaryReportApi
